module.exports = __webpack_public_path__ + "static/media/IKMS11.fb521401.jpg";